import React from 'react'
import { connect, Dispatch } from 'react-redux'
import { push } from 'react-router-redux'

import { Store, getUserInfo, UserInfo } from '../../reducers/index'
import { showLoginForm } from '../../actions/ui_actions'
import { Action } from '../../actions/types'
import { logout } from '../../actions/user'
import { withApollo } from 'react-apollo/withApollo'
import { ApolloClient } from 'apollo-client'
import { NormalizedCache } from 'apollo-cache-inmemory'

import NavLink from './NavLink'
import Confirmation from '../Shared/Alerts/Confirmation'

type Props = {
  showConfirmation: (show: boolean) => void
  confirmationShown: boolean

  userInfo: UserInfo
  className?: string
  showLogin: () => Action
  logout: () => Action

  client: ApolloClient<NormalizedCache>
}

class LoginView extends React.Component<Props> {
  logoutConfirmation = () => (
    <Confirmation onConfirm={this.confirmLogout} onCancel={this.cancelLogout}>
      Are you sure you want to log out?
    </Confirmation>
  )

  confirmLogout = () => {
    this.props.showConfirmation(false)
    this.props.logout()
  }

  cancelLogout = () => {
    this.props.showConfirmation(false)
  }

  render() {
    return this.props.userInfo ? (
      <div style={{ display: 'inline' }}>
        {this.props.confirmationShown && this.logoutConfirmation()}
        <span
          style={{ cursor: 'pointer' }}
          onClick={() => this.props.showConfirmation(true)}
        >
          Log out
        </span>
      </div>
    ) : (
      <NavLink onClick={this.props.showLogin}>Log in</NavLink>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  userInfo: getUserInfo(state)
})

const mapDispatchToProps = (
  dispatch: Dispatch<Store.Complete>,
  ownProps: Props
) => ({
  showLogin: () => dispatch(showLoginForm()),
  logout: () => {
    dispatch(logout(ownProps.client))
    dispatch(push('/'))
  }
})

export default withApollo(
  connect(mapStateToProps, mapDispatchToProps)(LoginView)
)



// WEBPACK FOOTER //
// ./src/Components/Layout/LoginView.tsx